// riskData.js
import manufacturingRiskData from './manufacturingRiskData';
import retailRiskData from './retailRiskData';
import commonHRRiskData from './commonHRRiskData';
import commonFinanceRiskData from './commonFinanceRiskData';


const riskData = [
  ...manufacturingRiskData,
  ...retailRiskData,
  ...commonHRRiskData,
  ...commonFinanceRiskData,

  ];

export default riskData;
